module.exports = __webpack_public_path__ + "img/project13_7.jpg.322aaac5.webp";